<template>
  <div class="container">
    <!-- pc头部 -->
    <div class="containerTop_PC">
      <div class="top">
        <div class="wrap clearfix">
          <div class="topl fl">{{$t('m.welcome')}}</div>
          <div class="topr fr">
            <div class="header_search">
              <el-input v-model="searchValue" >
                <i slot="suffix" class="el-input__icon el-icon-search" @click="handleSearch"></i>
              </el-input>
            </div>
            <div style="display: inline-block;">
              <a href="https://qiye.aliyun.com/" target="_blank" class="qyyx">{{$t('m.email')}}</a>
              <span class="cn" @click="changeLang('zh-CN')"><img src="../assets/img/cn.jpg">{{$t('m.chinese')}}</span>
              <span class="en" @click="changeLang('en-US')"><img src="../assets/img/en.jpg">En</span>
            </div>
          </div>
          <div class="clear" ></div>
        </div>
      </div>

      <div class="head_pc">
        <div class="wrap">
          <div class="head clearfix">
            <a href="/" class="logo fl"><img src="../assets/img/logoSin.jpg"></a>
            <div class="fr nav clearfix">
              <!-- 中文菜单 -->
              <ul v-if="$i18n.locale == 'zh-CN'">
                <li class="fl">
                  <a href="/" class="nava">首页</a>
                </li>
                <li class="fl" 
                  v-for="(item, index) in navList" :key="index" 
                  @mouseenter="navShow(item.channelId)"
                  @mouseleave="navClose()">
                  <a 
                    class="nava"
                    v-if="item.url && item.url !== ''" 
                    :href="item.item.url">
                    {{item.name}}
                  </a>
                  <!-- 企业概况 -->
                  <a 
                    class="nava"
                    v-if="item.entTChannelUuid == '0197'" 
                    :href="`/listPage/${item.child[0].entTChannelUuid}`">
                    {{item.name}}
                  </a>
                  <!-- 业务领域 -->
                  <a 
                    class="nava"
                    v-if="item.entTChannelUuid == '0198'" 
                    :href="`/business`">
                    {{ item.name }}
                  </a>
                  <!-- 企业文化 -->
                  <a 
                    class="nava"
                    v-if="item.entTChannelUuid == '0201'" 
                    :href="`/culture`">
                    {{ item.name }}
                  </a>
                  <!-- 招贤纳士 -->
                  <a 
                    class="nava"
                    v-if="item.entTChannelUuid == '0202'" 
                    :href="`/joinUs`">
                    {{ item.name }}
                  </a>
                  <!-- 联络我们 -->
                  <a 
                    class="nava"
                    v-if="item.entTChannelUuid == '02020001'" 
                    :href="`/contact`">
                    {{ item.name }}
                  </a>
                  <!-- 咨询动态、党的建设 -->
                  <a class="nava"
                    v-if="item.entTChannelUuid == '0199' || item.entTChannelUuid == '0200'" 
                    :href="item.catalog == 1 ? `/listPage/${item.entTChannelUuid}` : item.catalog == 2 ? `/list/${item.entTChannelUuid}` : `/listPic/${item.entTChannelUuid}`">
                    {{item.name}}
                  </a>

                  <el-collapse-transition>
                    <div class="nav_down" v-show="navDown == item.channelId">
                      <div class="nav_down_wrap" v-show="item.child.length != 0">
                        <p v-for="(item1, index1) in item.child" :key="index1">
                          <a class="nav_downa"
                            v-if="item1.url && item1.url !== ''" 
                            target="_blank" 
                            :href="item1.url">
                            {{item1.name}}
                          </a>
                          <a class="nav_downa"
                            v-if="(!item1.url || item1.url == '') && item1.entTChannelUuid != '02010001'" 
                            :href="item1.catalog === 1 ? `/listPage/${item1.entTChannelUuid}` : item1.catalog === 2 ? `/list/${item1.entTChannelUuid}` : `/listPic/${item1.entTChannelUuid}`">
                            {{item1.name}}
                          </a>
                          <a 
                            class="nav_downa"
                            v-if="item1.entTChannelUuid == '02010001'" 
                            :href="`/culture`">
                            {{ item1.name }}
                          </a>
                        </p>
                      </div>
                    </div>
                  </el-collapse-transition>
                </li>
                <div class="clear" ></div>
              </ul>
              <!-- 英文菜单 -->
              <ul v-if="$i18n.locale == 'en-US'">
                <li class="fl">
                  <a href="/" class="nava">Home</a>
                </li>
                <li class="fl" 
                  v-for="(item, index) in navListEn" :key="index" 
                  @mouseenter="navShow(item.channelId)"
                  @mouseleave="navClose()">
                  <a 
                    class="nava"
                    v-if="item.url && item.url !== ''" 
                    :href="item.item.url">
                    {{item.name}}
                  </a>
                  <!-- 企业概况 -->
                  <a 
                    class="nava"
                    v-if="item.entTChannelUuid == '0206'" 
                    :href="`/listPage/${item.child[0].entTChannelUuid}`">
                    {{item.name}}
                  </a>
                  <!-- 业务领域 -->
                  <a 
                    class="nava"
                    v-if="item.entTChannelUuid == '0207'" 
                    :href="`/business`">
                    {{ item.name }}
                  </a>
                  <!-- 企业文化 -->
                  <a 
                    class="nava"
                    v-if="item.entTChannelUuid == '0209'" 
                    :href="`/culture`">
                    {{ item.name }}
                  </a>
                  <!-- 招贤纳士 -->
                  <a 
                    class="nava"
                    v-if="item.entTChannelUuid == '0210'" 
                    :href="`/joinUs`">
                    {{ item.name }}
                  </a>
                  <!-- 联络我们 -->
                  <a 
                    class="nava"
                    v-if="item.entTChannelUuid == '0211'" 
                    :href="`/contact`">
                    {{ item.name }}
                  </a>
                  <!-- 咨询动态 -->
                  <a class="nava"
                    v-if="item.entTChannelUuid == '0208'" 
                    :href="item.catalog == 1 ? `/listPage/${item.entTChannelUuid}` : item.catalog == 2 ? `/list/${item.entTChannelUuid}` : `/listPic/${item.entTChannelUuid}`">
                    {{item.name}}
                  </a>

                  <el-collapse-transition>
                    <div class="nav_down" v-show="navDown == item.channelId">
                      <div class="nav_down_wrap" v-show="item.child.length != 0">
                        <p v-for="(item1, index1) in item.child" :key="index1">
                          <a class="nav_downa"
                            v-if="item1.url && item1.url !== ''" 
                            target="_blank" 
                            :href="item1.url">
                            {{item1.name}}
                          </a>
                          <a class="nav_downa"
                            v-if="(!item1.url || item1.url == '') && item1.entTChannelUuid != '02090001'" 
                            :href="item1.catalog === 1 ? `/listPage/${item1.entTChannelUuid}` : item1.catalog === 2 ? `/list/${item1.entTChannelUuid}` : `/listPic/${item1.entTChannelUuid}`">
                            {{item1.name}}
                          </a>
                          <a 
                            class="nav_downa"
                            v-if="item1.entTChannelUuid == '02090001'" 
                            :href="`/culture`">
                            {{ item1.name }}
                          </a>
                        </p>
                      </div>
                    </div>
                  </el-collapse-transition>
                </li>
                <div class="clear" ></div>
              </ul>
            </div>
            <div class="clear" ></div>
          </div>
        </div>      
      </div>
    </div>
    <!-- 手机端头部 -->
    <div class="containerTop_wap">
      <div class="head_wap">
        <div class="whead clearfix">
          <a href="/" class="wlogo fl"><img src="../assets/img/logoSin.jpg"></a>
          <i @click="wapTop"></i>
        </div>
        <div class="wpnvbg" v-show="iswapTop"></div>
        <div class="wapnav" v-show="iswapTop">
          <div class="wapnavtop">
            <i @click="wapTop"></i>
          </div>
          <div class="wapnava">
            <!-- 中文菜单 -->
            <div v-if="$i18n.locale == 'zh-CN'">
              <span class="fl">
                <a href="/" class="wapprda">首页</a>
              </span>
              <span class="fl" v-for="(item, index) in navList" :key="index" >
                <a 
                  @click="navShow(item.channelId)"
                  class="wapprda"
                  v-if="item.url && item.url !== ''" 
                  :href="item.item.url">
                  {{item.name}}
                  <i> <img src="../assets/img/ricon.png"> </i>
                </a>
                <!-- 招贤纳士 -->
                <a 
                  @click="navShow(item.channelId)"
                  class="wapprda"
                  v-if="item.entTChannelUuid == '0202'" 
                  :href="`/joinUs`">
                  {{item.name}}
                  <i> <img src="../assets/img/ricon.png"> </i>
                </a>
                <!-- 联络我们 -->
                <a 
                  @click="navShow(item.channelId)"
                  class="wapprda"
                  v-if="item.entTChannelUuid == '02020001'" 
                  :href="`/contact`">
                  {{item.name}}
                  <i> <img src="../assets/img/ricon.png"> </i>
                </a>
                <a 
                  @click="navShow(item.channelId)"
                  class="wapprda"
                  v-if="item.child.length" 
                  >
                  {{item.name}}
                  <i> <img src="../assets/img/ricon.png"> </i>
                </a>

                <div class="wpheadhide" v-show="navDown == item.channelId && isMenu">
                  <p v-for="(item1, index1) in item.child" :key="index1">
                    <a
                      v-if="item1.url && item1.url !== ''" 
                      target="_blank" 
                      :href="item1.url">
                      {{item1.name}}
                    </a>
                    <a
                      v-if="(!item1.url || item1.url == '') && item1.entTChannelUuid != '02010001'" 
                      :href="item1.catalog === 1 ? `/listPage/${item1.entTChannelUuid}` : item1.catalog === 2 ? `/list/${item1.entTChannelUuid}` : `/listPic/${item1.entTChannelUuid}`">
                      {{item1.name}}
                    </a>
                    <a 
                      v-if="item1.entTChannelUuid == '02010001'" 
                      :href="`/culture`">
                      {{ item1.name }}
                    </a>
                  </p>
                </div>
              </span>
            </div>
            <!-- 英文菜单 -->
            <div v-if="$i18n.locale == 'en-US'">
              <span class="fl">
                <a href="/" class="wapprda">Home</a>
              </span>
              <span class="fl" v-for="(item, index) in navListEn" :key="index" >
                <a 
                  @click="navShow(item.channelId)"
                  class="wapprda"
                  v-if="item.url && item.url !== ''" 
                  :href="item.item.url">
                  {{item.name}}
                  <i> <img src="../assets/img/ricon.png"> </i>
                </a>
                <!-- 招贤纳士 -->
                <a 
                  @click="navShow(item.channelId)"
                  class="wapprda"
                  v-if="item.entTChannelUuid == '0210'" 
                  :href="`/joinUs`">
                  {{item.name}}
                  <i> <img src="../assets/img/ricon.png"> </i>
                </a>
                <!-- 联络我们 -->
                <a 
                  @click="navShow(item.channelId)"
                  class="wapprda"
                  v-if="item.entTChannelUuid == '0211'" 
                  :href="`/contact`">
                  {{item.name}}
                  <i> <img src="../assets/img/ricon.png"> </i>
                </a>
                <a 
                  @click="navShow(item.channelId)"
                  class="wapprda"
                  v-if="item.child.length" 
                  >
                  {{item.name}}
                  <i> <img src="../assets/img/ricon.png"> </i>
                </a>

                <div class="wpheadhide" v-show="navDown == item.channelId && isMenu">
                  <p v-for="(item1, index1) in item.child" :key="index1">
                    <a
                      v-if="item1.url && item1.url !== ''" 
                      target="_blank" 
                      :href="item1.url">
                      {{item1.name}}
                    </a>
                    <a
                      v-if="(!item1.url || item1.url == '') && item1.entTChannelUuid != '02090001'" 
                      :href="item1.catalog === 1 ? `/listPage/${item1.entTChannelUuid}` : item1.catalog === 2 ? `/list/${item1.entTChannelUuid}` : `/listPic/${item1.entTChannelUuid}`">
                      {{item1.name}}
                    </a>
                    <a 
                      v-if="item1.entTChannelUuid == '02090001'" 
                      :href="`/culture`">
                      {{ item1.name }}
                    </a>
                  </p>
                </div>
              </span>
            </div>


            <div class="fl search w100">
              <el-input v-model="searchValue" :placeholder="$t('m.searchTxt')" size="medium">
                <i slot="suffix" class="el-input__icon el-icon-search" @click="handleSearch"></i>
              </el-input>
            </div>
            <div class="clearfix fl cnen">
              <span class="cn" @click="changeLang('zh-CN')"><img src="../assets/img/cn.jpg">{{$t('m.chinese')}}</span>
              <span class="en" @click="changeLang('en-US')"><img src="../assets/img/en.jpg">En</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="main">
      <router-view></router-view>
    </div>

    <div class="foot">
      <div class="wrap clearfix">
        <a href="" class="flogo fl" v-if="$i18n.locale == 'zh-CN'">
          <img src="../assets/img/flogo.png">
        </a>
        <a href="" class="flogo fl" v-if="$i18n.locale == 'en-US'">
          <img src="../assets/img/enLogo.png">
        </a>
        <div class="fmenu fl" v-html="$t('m.footerLeft')">
        </div>

        <div class="fr ewm">
          <a href=""><img src="../assets/img/1-200616111RK91.png"></a>
          <a href=""><img src="../assets/img/1-200430154QR25.jpeg"></a>
        </div>
        <div class="clear" ></div>
      </div>
    </div>
  </div>
</template>
<script>
import {getNavChannel} from '@/api/common'
export default {
  data(){
    return {
      lang: 'zh-CN',
      isMenu: false,
      iswapTop: false,
      searchValue: '',
      active: 0,
      imgList: [],
      navList: [],
      navListEn: [],
      newsTop: [],
      navDown: 0,
    }
  },
  filters: {
    ellipsis: function(value) {
      if (!value) return "";
      if (value.length > 130) {
        return value.slice(0, 130) + "...";
      }
      return value;
    }
  },
  mounted(){
    var _this = this
    this.getPath()
    this.getNavChannel()
    this.getNavChannelEn()
    _this.$i18n.locale = _this.getCookie('lang') || 'zh-CN'
  },
  created(){

  },
  watch:{
    '$route':'getPath'
  },
  methods: {
    setCookie (name,value,perpetual) {
      let exdate = new Date()
      exdate.setDate(exdate.getDate() + perpetual)  //exdate.setDate(exdate.getDate() + 365)
      document.cookie = name + '=' + value + ';expires=' + exdate.toGMTString()
    },
    getCookie(name){
      if (document.cookie.length > 0) {
        var start = document.cookie.indexOf(name + '=')
        if (start !== -1) {
          start = start + name.length + 1
          let end = document.cookie.indexOf(';', start)
          if (end === -1) end = document.cookie.length
          return unescape(document.cookie.substring(start, end))
        }
      }
      return ''
    },
    delCookie (name) {
      var _this = this
      var exp = new Date();
      exp.setTime(exp.getTime() - 1);
      var cval = _this.getCookie(name);
      if (cval && cval != null) {
        document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString();
      }
    },
    beforeunloadHandler() {
      localStorage.removeItem("lang")
    },
    changeLang(val) {
      var _this = this

      _this.$i18n.locale = val
      _this.lang = val
      _this.setCookie("lang", val, 1)
      _this.$router.push({path:'/'})
      localStorage.setItem('lang', val)
      
    },
    wapTop(){
      this.iswapTop = !this.iswapTop
    },
    // 获取导航-中文
    getNavChannel() {
      var _this = this
      let data = {
        applicationUuid: _this.webId
      }
      getNavChannel(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.navList = data.slice(0, 7)
        }
      })
    },
    // 获取导航-英文
    getNavChannelEn() {
      var _this = this
      let data = {
        applicationUuid: _this.webIdEn,
      }
      getNavChannel(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.navListEn = data.slice(0, 6)
        }
      })
    },
    handleSearch() {
      var _this = this
      if (!_this.searchValue || _this.searchValue == '') {
        this.$message({
          message: '请输入关键词',
          type: 'warning'
        })
      } else {
        window.location.href = `/search/${_this.searchValue}`
      }
    },
    // 二级导航展开
    navShow(d){
      let _this = this
      // _this[d] = true
      _this.navDown = d
      this.isMenu = !this.isMenu
    },
    // 二级导航收起
    navClose(){
      let _this = this
      // _this[d] = false
      _this.navDown = 0
    },
    haddleNav(index, params){
      var _this = this

      _this.active = index
      _this.$router.push(params.url)
    },
    getPath(){
      var _this = this

      _this.active = _this.$route.meta.index
    },
  }
}
</script>
<style>
.clear{
  clear: both;
}
.containerTop_PC {
  display: block;
}
.containerTop_wap{
  display: none;
  height: 70px;
}
.top {
    height: 35px;
    line-height: 35px;
    background: #f0f0f0;
    display: block;
  }
  .top .topl {
    font-size: 16px;
    color: #666666;
  }
  .header_search{
  display: inline-block;
  margin-right: 20px;
  }
  .header_search input {
    width: 160px;
    height: 22px;
    overflow: hidden;
    outline: none;
    box-shadow: none;
    line-height: 22px;
    font-size: 14px;
    color: #585858;
    border: solid 1px #CECECE;
    border-radius: 10px;
    margin-top: 5px;
    background-color: #f0f0f0;
  }
  .el-input__suffix {
    position: absolute;
    top: -3px;
    height: 100%;
    color: #000000;
    text-align: center;
    font-weight: 800;
  }
  .el-input__icon {
    height: 100%;
    width: 25px;
    text-align: center;
    transition: all .3s;
    line-height: 40px;
    font-weight: 900;
  }
  .top .topr a.qyyx {
    color: #999999;
    font-size: 14px;
    margin-right: 32px;
  }
  .top .topr .cn {
    color: #999;
    font-size: 14px;
    margin-right: 30px;
  }
  .top .topr .cn img {
    vertical-align: middle;
    margin-right: 5px;
  }
  .top .topr .en {
    color: #999;
    font-size: 14px;
  }
  .top .topr .en img {
    vertical-align: middle;
    margin-right: 5px;
  }

  /* 导航 */
  .head_pc {
    display: block;
  }
  .wrap {
    width: 1200px;
    margin: 0 auto;
  }
  .head_pc .head {
    height: 90px;
  }
  .head_pc .head a.logo {
    margin: 10px 0 0 0;
  }

  .head_pc .nav ul {
    margin-top: 40px;
  }
  .head_pc .nav ul li {
    position: relative;
  }
  .head_pc .nav ul li {
    padding: 0 20px;
    position: relative;
  }
  .head_pc .nav ul li.active .nava {
    color: #0062b1;
  }
  .head_pc .nav ul li .nava {
    display: block;
    font-size: 16px;
    color: #333;
    padding-bottom: 10px;
  }
  .head_pc .nav ul li .nava:hover {
    color: #0062b1;
  }
  .nav_down{
    position: absolute;
    z-index: 9999999;
    left: 0;
    width: 100%;
  }
  .nav_down p{
    text-align: center;
    height: 34px;
    line-height: 34px;
    background-color: #fff;
  }
  .nav_down p .nav_downa {
    height: 34px;
    line-height: 34px;
    display: block;
    font-weight: normal;
    font-size: 14px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    color: #666;
    font-family: "Microsoft YaHei";
  }


  .foot {
    background: url(../assets/img/foot_bg.jpg) no-repeat;
    height: 150px;
    background-size: cover;
  }
  .wrap {
    width: 1200px;
    margin: 0 auto;
  }
  .foot a.flogo {
    margin-top: 22px;
  }

  a {
    text-decoration: none;
    /* display: inline-block; */
    color: #333;
    /* transition: all 0.25s; */
  }
  img {
    max-width: 100%;
  }
  img {
    border: none;
    display: inline-block;
  }
  .foot .fmenu {
    color: #fff;
    font-size: 16px;
    line-height: 36px;
    padding-top: 45px;
    margin-left: 60px;
  }
  .foot .fmenu a {
    color: #fff;
    padding: 0 10px;
  }
  .foot .fmenu span {
    color: #fff;
  }
  .foot .ewm {
    margin-top: 25px;
  }

  .foot .ewm img:nth-child(1) {
    margin-left: 16px;
  }
  .foot .ewm img {
    height: 96px;
    width: 96px;
  }

  /* 手机端头部样式 */
  .whead {
    height: 70px;
    background: #fff;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 9999;
    box-shadow: 0 0 15px rgba(0,0,0,.15);
  }

  .wlogo {
    display: inline-block;
    margin-left: 10px;
    margin-top: 17px;
  }

  .whead i {
    display: block;
    width: 70px;
    height: 70px;
    background: url(../assets/img/navicon.jpg) no-repeat center;
    color: #fff;
    text-align: center;
    line-height: 70px;
    font-size: 18px;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 99999999;
  }
  .wpnvbg {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9999;
    background: rgba(0,0,0,.7);
    opacity: 1;
    visibility: inherit;
    transition: .25s;
  }
  .wapnavtop {
    background: #fff;
    color: #fff;
    height: 70px;
    line-height: 70px;
    padding: 0 15px;
  }
  .wapprda i, .wapprda1 i {
    display: block;
    position: absolute;
    right: 20px;
    top: 18px;
    height: 44px;
    line-height: 44px;
  }
  .wapnavtop i {
    display: block;
    width: 70px;
    height: 70px;
    background: none;
    color: #222;
    text-align: center;
    line-height: 50px;
    font-size: 18px;
    position: absolute;
    background: url(../assets/img/navicon.jpg) no-repeat center;
    right: 0;
    top: 0;
    z-index: 99999999;
  }
  .wapnava {
    padding: 0 20px 20px 20px;
  }
  .wapnava span {
    width: 100%;
  }

  .wapnava a {
    display: block;
    height: 44px;
    line-height: 43px;
    padding: 0 15px;
    color: #444;
    width: 100%;
    border-bottom: 1px dashed #eee;
  }
  .wapprda, .wapprda1 {
    position: relative;
  }
  .wapprda i img, .wapprda1 i img {
    height: 10px;
  }
  img {
    max-width: 100%;
  }
  .wpheadhide a {
    font-size: 13px;
    padding-left: 30px;
  }
  .wapnava a {
    display: block;
    height: 44px;
    line-height: 43px;
    padding: 0 15px;
    color: #444;
    width: 100%;
    border-bottom: 1px dashed #eee;
    box-sizing: border-box;
  }
  .wapnava .cnen {
    width: 100%;
  }
  .wapnava .cnen span {
    width: 50%;
    float: left;
    margin-top: 20px;
  }
  .wapnava .cnen span img {
    vertical-align: middle;
    margin-right: 10px;
  }
  img {
    max-width: 100%;
  }
  .search {
    padding: 0;
    margin-top: 15px;
  }
  .wlogo img {
    display: block;
    border: 0;
    height: 36px;
  }
  .wapnav {
    width: 240px;
    height: 100%;
    position: fixed;
    right: 0;
    top: 0;
    background: #fff;
    z-index: 9999;
    /* margin-right: -240px; */
    transition: .25s;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }
  .wapnava .search .el-input__icon {
    width: 40px;
    text-align: center;
    transition: all .3s;
    font-weight: 900;
    background-color: #f0f0f0;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
  }
  .wapnava .search .el-input__suffix {
    position: absolute;
    top: 0;
    height: 100%;
    color: #959191;
    text-align: center;
    font-weight: 900;
  }
  .wapnava .search .el-input__suffix {
    right: -79px;
    transition: all .3s;
  }

  @media (max-width: 1300px) {
  .wrap {
    width: 100% !important;
  }
  .head_pc .head {
      height: auto;
  }
  .head_pc .nav {
    width: 100%;
  }
  .head_pc .nav ul {
    margin-top: 40px;
    text-align: center;
  }
  .head_pc .nav ul li {
    padding: 0 20px;
    display: inline-block;
    float: none;
  }

  }
  @media (max-width: 992px) {
    .wrap {
    width: 100% !important;
    /* padding: 0 15px; */
  }
  .foot {
    height: auto;
    background-size: cover;
    padding-bottom: 20px;
  }
  .fmenu{
    text-align: center;
  }
  .ewm{
    width: 100%;
    text-align: center;
  }
  .flogo{
    width: 20%;
    text-align: center;
  }
    
  }
  @media (max-width: 950px) {
  .containerTop_PC {
    display: none; 
  }
  .containerTop_wap{
    display: block;
  }

  }
  @media (max-width: 768px) {
  .containerTop_PC {
    display: none;
  }
  .containerTop_wap{
    display: block;
  }
  .wrap {
    width: 100% !important;
    /* padding: 0 15px; */
  }
  .foot a.flogo {
    display: block;
    width: 100%;
    text-align: center;
  }
  .foot .fmenu span {
    display: inline-block;
    padding: 0 6px;
  }
  .foot .ewm {
    width: 100%;
    text-align: center;
  }
  .foot .ewm a {
    display: inline-block;
    width: 30%;
    padding: 0 5%;
    box-sizing: unset;
  }
  .foot .ewm img:nth-child(1) {
    margin-right: 0;
    width: 100%;
    height: auto;
  }
  img {
    max-width: 100%;
  }
  img {
    border: none;
    display: inline-block;
  }
  .foot {
    height: auto;
    background-size: cover;
    padding-bottom: 20px;
  }
  .foot .fmenu {
    margin: 0;
    font-size: 12px;
    text-align: center;
    width: 100%;
  }
  .foot .ewm img:nth-child(1) {
    margin-left: 0px;
  }
  }

  </style>